import { bindActionCreators } from 'redux';

function mapDispatchtoActionProp(actionCreators) {
    return (dispatch) => ({
        actions: bindActionCreators(actionCreators, dispatch),
    });
}

export { mapDispatchtoActionProp as default };
